import { render, staticRenderFns } from "./ProdEdit.vue?vue&type=template&id=2446d464&scoped=true&"
import script from "./ProdEdit.vue?vue&type=script&lang=js&"
export * from "./ProdEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446d464",
  null
  
)

export default component.exports